module.exports = __webpack_public_path__ + "img/bg.218fe058.png";